import { Mail, Send } from 'lucide-react';
import { LOGIN_URL, REGISTER_URL } from '../lib/links';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <a href="#top" className="brand">
              <span className="brand-mark">
                <span>A</span>
              </span>
              <span>
                ALPHA ONE
                <small>Web3 Ecosystem</small>
              </span>
            </a>
            <p>
              A next-generation decentralized Web3 ecosystem powered by the LDS Token —
              empowering the future through blockchain innovation.
            </p>
          </div>

          <div>
            <h5>Platform</h5>
            <ul>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#ecosystem">Ecosystem</a>
              </li>
              <li>
                <a href="#income">Income Plan</a>
              </li>
              <li>
                <a href="#roadmap">Roadmap</a>
              </li>
            </ul>
          </div>

          <div>
            <h5>Account</h5>
            <ul>
              <li>
                <a href={REGISTER_URL}>Create Account</a>
              </li>
              <li>
                <a href={LOGIN_URL}>Member Login</a>
              </li>
              <li>
                <a href="#activation">Activation Package</a>
              </li>
            </ul>
          </div>

          <div>
            <h5>Support</h5>
            <ul>
              <li>
                <a href="mailto:support@alphaone.io">
                  <Mail size={14} style={{ display: 'inline', marginRight: 6 }} />
                  support@alphaone.io
                </a>
              </li>
              <li>
                <a href="https://t.me/alphaone_official" target="_blank" rel="noreferrer">
                  <Send size={14} style={{ display: 'inline', marginRight: 6 }} />
                  Telegram Channel
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {year} Alpha One. All rights reserved.</span>
          <span>All rewards are distributed in LDS Tokens. Terms &amp; Conditions apply.</span>
        </div>
      </div>
    </footer>
  );
}
